import type { FlexProps } from '@chakra-ui/react';
import { Flex, HStack, Text } from '@chakra-ui/react';
import { Address } from '@ui/components/Address';
import { UsdValue } from '@ui/components/Num/UsdValue';
import type { UserAgent } from '@ui/hooks/api/useUserAgents';
import { formatDistanceToNow } from 'date-fns';
import { useMemo } from 'react';

type TokenListRowInfoProps = FlexProps & {
  userAgent: UserAgent;
};
export const TokenListRowInfo = ({
  userAgent,
  ...props
}: TokenListRowInfoProps) => {
  const createdAtNode = useMemo(() => {
    return userAgent.created_at
      ? formatDistanceToNow(userAgent.created_at, {
          addSuffix: true,
        })
      : '';
  }, [userAgent.created_at]);

  return (
    <Flex flexDir="column" {...props}>
      <HStack>
        <HStack w="50%" justifyContent="space-between">
          <Text textStyle="body3">MCAP</Text>
          <UsdValue
            value={userAgent.market_cap}
            price={1}
            isShowUnit
            textStyle="body3Bold"
          />
        </HStack>
        <HStack
          w="50%"
          justifyContent="space-between"
          borderLeftWidth="1px"
          borderColor="secondary.orange"
          pl="8px"
        >
          <Text textStyle="body3">24h Vol</Text>
          <UsdValue
            value={userAgent.vol24h}
            price={1}
            isShowUnit
            textStyle="body3Bold"
          />
        </HStack>
      </HStack>
      <Text
        textStyle="caption"
        color="text.secondary"
        textAlign="right"
        lineClamp={1}
        wordBreak="break-all"
        mt="8px"
      >
        Created {createdAtNode} by{' '}
        {userAgent.creator_address ? (
          <Address
            as="span"
            display="inline"
            address={userAgent.creator_address}
          />
        ) : (
          '--'
        )}
      </Text>
    </Flex>
  );
};
